import { defineStore } from 'pinia'

interface RefreshState {
  refreshKey: number
}

const initialState: RefreshState = {
  refreshKey: 0
}

// Pinia Store の定義
export const useRefreshStore = defineStore('refresh', {
  state: (): RefreshState => ({ ...initialState }),
  actions: {
    reset() {
      Object.assign(this.$state, initialState)
    },
    triggerRefresh(): void {
      this.refreshKey++
    }
  }
})
